<div class="wrapper">
  <div class="container-fluid">

    <!-- start page title -->
    <div class="row">
      <div class="col-12">
        <div class="page-title-box">
          <div class="page-title-right">
            <ol class="breadcrumb m-0">
              <!-- <li class="breadcrumb-item"><a href="javascript: void(0);">Home</a></li> -->
              <li class="breadcrumb-item active">Credit Balance</li>
            </ol>
          </div>
          <h4 class="page-title">Credit Balance Check</h4>
        </div>
      </div>
    </div>
    <!-- end page title -->


    <div class="row">
      <div class="col-12">

        <div class="card-box">
          <h4 class="header-title">Credit available</h4>
          <p class="sub-header">
            Balance inquiry
          </p>

          <div class="row">
            <div class="form-group" *ngIf="raiseWarning" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert [dismissible]="false" style="width:100%;">
                  <strong>Warning!</strong> {{warning}}
                </ngb-alert>
              </div>
            </div>

            <div class="form-group" *ngIf="raiseDanger" style="width:100%;">
              <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                <ngb-alert type="danger" [dismissible]="false" style="width:100%;">
                  <strong>Error!</strong> {{danger}}
                </ngb-alert>
              </div>
            </div>
          </div>
          <div class="row form-horizontal">
            <div class="col-md-6 form-horizontal px-3">

              <div class="form-group row">
                <label class="col-3 col-form-label">Card Number </label>
                <div class="col-6">
                  <input class="form-control" type="text" name="PAN" [(ngModel)]="PAN" [ngModelOptions]="{standalone: true}" required maxlength="19" minlength="12">
                </div>
                <div class="col-3">
                  <button type="submit" class="btn btn-info waves-effect waves-light float-right" (click)="submit()">
                    View <i class="mdi mdi-pencil-box-outline"></i>
                  </button>
                </div>
              </div>


              <div class="form-group row" *ngIf="success" style="width:100%;">
                <div class="col-md-12 form-horizontal px-6" style="width:100%;">
                  <ngb-alert type="info" [dismissible]="false" style="width:100%;">
                    <strong></strong> {{message}}
                  </ngb-alert>
                </div>
              </div>

            </div>
          </div>
        </div>
    </div>
  </div> <!-- end container -->
</div>
